<template>
  <div>
    <div style="background: #fff" class="todaySelected-top1">
      <!-- <van-list
          v-model="loading"
          :finished="finished"
          :finished-text="more"
          @load="onLoad"
        > -->
      <div v-if="list.length > 0">
        <div
          class="stock_mybody"
          v-for="(item, index) in list"
          :key="index"
          @click="toSearchProduct(item)"
        >
          <div style="width: 1.95rem">
            <div class="top" style="font-size: 0.32rem; font-weight: 500">
              {{ item.stkName }}
            </div>
            <div class="bottom">
              {{ item.marketValue }}
            </div>
          </div>
          <div style="width: 1.93rem; font-weight: 500">
            <div
              class="top"
              :class="[
                item.profit > 0
                  ? 'stock-list-red'
                  : item.profit < 0
                  ? 'stock-list-green'
                  : 'stock-list-333',
              ]"
            >
              {{
                (
                  (Number(item.stkPrice) - Number(item.buyAvg)) *
                  Number(item.stkSum)
                ).toFixed(2)
              }}
            </div>
            <div
              class="bottom"
              :class="[
                item.profit > 0
                  ? 'stock-list-red'
                  : item.profit < 0
                  ? 'stock-list-green'
                  : 'stock-list-ccc',
              ]"
            >
              {{ item.profitrate }}
            </div>
          </div>
          <div style="width: 1.3rem; font-weight: 500">
            <div class="top">
              <!-- {{ item.stockName }} -->
              {{ item.stkSum }}
            </div>
            <div class="bottom">
              <!-- {{ item.stockCode.slice(0, 6) }} -->
              {{ item.stkBalanceSum }}
            </div>
          </div>

          <div
            style="
              width: 1.65rem;
              text-align: right;
              font-size: 0.34rem;
              font-weight: 500;
            "
          >
            <div class="top">
              <!-- {{ item.stockName }} -->
              {{ item.buyAvg }}
            </div>
            <div class="bottom">
              <!-- {{ item.stockCode.slice(0, 6) }} -->
              {{ item.stkPrice }}
            </div>
          </div>
        </div>
      </div>
      <div v-else class="wushuju" v-show="show">
        <img src="../assets/wushuju.png" alt="" />
        <p>暂无数据</p>
      </div>
      <!-- </van-list> -->
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: Array,
  },
  data() {
    return {
      show: false,
    };
  },
  watch: {
    list: function (newVal, oldVal) {
      //不能用箭头函数
      // console.log(newVal, oldVal);
      if (newVal.lengtn == 0) {
        this.show = true;
      } else {
        this.show = false;
      }
    },
  },
  methods: {
    toSearchProduct(item) {
      this.$emit("parentEvent", item);
    },
  },
};
</script>

<style lang="less" scoped>
.main-centent {
  padding: 0 0 0 0.32rem;
  border-bottom: 0.01rem solid rgba(237, 237, 237, 1);
}
.todaySelected-top {
  height: 0.5rem;
  font-size: 0.36rem;
  font-weight: bold;
  color: #333333;
  line-height: 0.5rem;
}
.todaySelected-title {
  height: 0.76rem;
  color: #666666;
  //   margin: 0 0 0 0.32rem;
  font-size: 0.24rem;

  display: flex;
  justify-content: initial;
  align-items: center;

  div:nth-child(4) {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    img {
      width: 0.44rem;
      height: 0.44rem;
    }
  }
}
.stock_mybody {
  height: 1.2rem;
  display: flex;
  /* justify-content: space-between; */
  align-items: center;
  padding: 0 0.32rem;
  font-size: 0.3rem;
  border-bottom: 0.01rem solid #e8e8e8;
}
.stock_mybody .van-collapse-item {
  padding: 0 0 0 0 !important;
}
.bottom {
  font-size: 0.28rem;
  color: #999999;
}
.top {
  color: #333333;
  font-size: 0.36rem;
  line-height: 0.5rem;
}
.stock-list-red {
  color: #f44336;
}
.stock-list-green {
  color: #1aaa52;
}
.stock-list-333 {
  color: #333;
}
.stock-list-ccc {
  color: #999;
}
.wushuju {
  height: 4rem;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 1.7rem;
  img {
    height: 4rem;
    width: 4rem;
  }
}
</style>